import React from "react";

const BackgroundDiv = ({
  backgroundColor,
  opacity,
  borderBottom,
  borderTop,
  noBorder,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor,
        borderRadius: borderBottom
          ? ".5rem.5rem 0 0"
          : borderTop
          ? "0 0 .5rem.5rem"
          : noBorder
          ? "0"
          : ".5rem.5rem",
        opacity,
      }}
    />
  );
};

export default BackgroundDiv;
